<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div v-if="type != 'add'">
        <span>采摘批次：</span>
        <span>{{ form.bizNo }}</span>
      </div>
    </div>

    <el-form :model="form" ref="form" :rules="rules" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="果园编号">
            <el-input disabled v-model="form.plantationBizNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="果园名称">
            <el-input disabled v-model="form.plantationName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="果园区域">
            <el-input disabled v-model="form.locName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="果园定位">
            <el-input disabled v-model="form.geoPosDetails"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            label="监园人员"
            prop="qcOperatorIds"
          >
            <el-select
              v-model="form.qcOperatorIds"
              multiple
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in observeList"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item 
            label="采摘日期"
            prop="pickingDateTime"
          >
            <el-date-picker v-model="form.pickingDateTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item label="备注">
            <el-input
              :rows="3"
              resize="none"
              type="textarea"
              maxlength="300"
              v-model="form.remark"
              placeholder="300字以内"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { modifyPickingBatchTask, getPickingBatchTaskDetail } from '@/api/system/manage'
import { userByRoleList } from '@/api/system/system'

export default {
  data() {
    return {
      form: {
        bizType: 0,
        pickingDateTime: '',
        qcOperatorIds: [],
        remark: '',
      },
      observeList: [],
      rules: {
        qcOperatorIds: [{ required: true, message: '请选择监园人员', trigger: ['blur','change'] }],
        pickingDateTime: [{ required: true, message: '请选择日期', trigger: 'blur' }],
      }
    }
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  created() {
    this.getUserByRoles()
  },
  methods: {
    getUserByRoles(){
      userByRoleList({roleName: '监园员'}).then(res => {
        if (res.flag) {
          this.observeList = res.data.map(item=>{
            item.userId = item.id
            delete item.id
            return item
          })
        }
      })
    },
    getDetails(row){
      if(row){
        if(this.type == 'edit'){
          this.getTaskInfo(row.id)
        }else{
          this.form = Object.assign(this.form,{
            ...row,
            pickingBatchId: row.id,
            locName: this.formatLocal(row.locDetails, 3),
            pickingDateTime: '',
            remark: '',
          })
        }
      }
    },
    getTaskInfo(id){
      getPickingBatchTaskDetail(id).then(res => {
        if (res.flag) {
          this.form = {
            ...res.data,
            pickingBatchTaskId: res.data.id,
            bizNo: res.data.pickingBatchBizNo,
            locName: this.formatLocal(res.data.locDetails, 3),
            pickingDateTime: this.parseTime(res.data.pickingDateTime, '{y}-{m}-{d}'),
            qcOperatorIds: JSON.parse(res.data.supervisorIdList).map(item=>item.userId)
          }
        }
      })
    },
    submit(){
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let reqList = []
            this.form.qcOperatorIds.forEach(d=>{
              let obs = this.observeList.find(o=>o.userId == d)
              reqList.push(obs)
            })
            let result = await modifyPickingBatchTask({
              remark: this.form.remark,
              pickingBatchId: this.form.pickingBatchId,
              pickingBatchTaskId: this.form.pickingBatchTaskId,
              pickingDateTime: this.form.pickingDateTime,
              purchasePlanId: this.form.purchasePlanId,
              type: this.type == 'edit' ? 2 : 1,
              reqList,
            })
            if(result.code == 200 && result.flag){
              this.$message.success('修改成功')
              resolve()
            }else{
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    reset(){
      this.resetForm('form')
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-select, .el-date-editor {
  width: 100%;
}
</style>